import './Logo.css';
import logoImg from '../../../../images/logo.webp';

export const Logo = () => {
    return <img src={logoImg} alt="" />;
};
